<template>
  <div class="d-inline-block">
    <button class="btn btn-soft btn-info w-100" @click="active = true"><i class="fab fa-youtube"></i> {{ title }}</button>
    <ModalView v-model:active="active" size="xlarge">
      <template v-slot:header>
        <div class="d-flex align-items-center justify-content-between g-4">
          <h3 class="mb-0">{{ title }}</h3>
          <ModalCloseButtonView @click="active = false"/>
        </div>
      </template>
      <template v-slot:body>
        <div class="aspect-fit">
          <iframe :src="url" frameborder="0" class="rounded-lg shadow" :title="title" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </template>
    </ModalView>
  </div>
</template>

<script setup>
import {ModalCloseButtonView, ModalView} from "@niftybit/vue";
import {ref} from "vue";

defineProps({
  title: String,
  url: String
});

const active = ref(false);

</script>

<style scoped>
  .aspect-fit {
    position: relative;
    width: 100%;
    height: 0;
    padding-bottom: 56.25%;
  }
  .aspect-fit iframe {
    position: absolute;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
  }
</style>